import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import qs from 'qs'

const FeatureState = State({
  initial: {
    list: [],
    currentFeature: null
  },
  addToFeaturesList (state, items) {
    return {
      ...state,
      list: state.list.concat(items)
    }
  },
  setFeatureList (state, items) {
    return {
      list: items
    }
  },
  setCurrentFeature (state, item) {
    return {
      currentFeature: item
    }
  }
})

// eslint-disable-next-line
const featureListEffect = Effect('featureList', (page) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({page: page})
  return axios.get(`${apiAddress}feature/list${urlParams}`).then((res) => {
    Actions.addToFeaturesList(res.data)
    return res
  })
})

// eslint-disable-next-line
const featureInfoEffect = Effect('featureInfo', (id) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({id: id})
  return axios.get(`${apiAddress}feature/info${urlParams}`).then((res) => {
    Actions.setCurrentFeature(res.data)
    return res
  })
})

// eslint-disable-next-line
const addFeatureEffect = Effect('addFeature', (values) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(values)
  return axios.post(`${apiAddress}feature/add`, urlParams)
})

// eslint-disable-next-line
const addPointToFeatureEffect = Effect('addPointToFeature', (values) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(values)
  return axios.post(`${apiAddress}feature/point`, urlParams).then((res) => {
    return {...res, updatedFeature: Actions.featureInfo(values.id)}
  })
})

export default FeatureState



// WEBPACK FOOTER //
// ./src/states/feature.js